
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35177',
  depVersions: {
  "documents-public-ui": "static-1.35177",
  "atom": "static-1.5358",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2766",
  "client-types": "static-1.496",
  "cssUtils": "static-1.893",
  "customer-data-filters-ui": "static-1.40836",
  "customer-data-objects": "static-1.7963",
  "customer-data-property-utils": "static-1.8375",
  "documents-lib": "static-1.35182",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.365",
  "FormsCommonComponents": "static-1.86509",
  "FormUrlGenerator": "static-2.5000",
  "foundations-theming-specialty": "static-1.2463",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5870",
  "hs-test-utils": "static-1.8305",
  "hub-http": "static-1.6486",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12066",
  "HubStyleTokens": "static-2.11759",
  "I18n": "static-7.1668",
  "icons": "static-2.677",
  "jasmine-immutable": "static-1.3294",
  "jasmine-runner": "static-1.6725",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7424",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3168",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5671",
  "quartz": "static-1.7422",
  "react": "static-7.192",
  "react-dlb": "static-1.88",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16990",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5537",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8455",
  "reference-resolvers-lite": "static-1.8376",
  "reporting-data": "static-1.68727",
  "reporting-reports": "static-1.68404",
  "reporting-snowflake": "static-1.57344",
  "reporting-testing-lib": "static-1.10660",
  "reporting-visualizations": "static-1.60802",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9224",
  "sanitize": "static-1.4747",
  "sanitize-text": "static-1.8427",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2020",
  "signup-constants": "static-1.19565",
  "signup-ui-url-generator": "static-2.8335",
  "StyleGuideUI": "static-3.500",
  "superstore": "static-1.5030",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5031",
  "ui-addon-form-validation": "static-1.11256",
  "ui-asset-management-lib": "static-1.11371",
  "ui-images": "static-2.1238",
  "UIComponents": "static-3.8705",
  "usage-tracker": "static-1.7629",
  "usage-tracker-container": "static-1.7619",
  "usage-tracker-core": "static-1.7479",
  "viral-links-lib": "static-1.7349",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9931",
  "foundations-components": "static-1-ech-accordiontransition-jank.26",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1200",
  "quartz-core": "static-1.6641",
  "quick-fetch": "static-1.4111",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4938",
  "ui-addon-i18n": "static-1.11419",
  "ui-addon-upgrades": "static-9.18347",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3600",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3699",
  "quartz-webpack": "static-1.3646",
  "foundations-assets": "static-1.5156",
  "foundations-theming": "static-1.4747",
  "hub-http-janus": "static-1.874",
  "hub-http-shared-msw-handlers": "static-1.10573",
  "hubspotter-http": "static-1.4844",
  "sassPrefix": "static-1.166",
  "conversations-skeleton-state": "static-1.7519",
  "crm-message-bus": "static-1.43702",
  "customer-data-filters-ui-msw-helpers": "static-1.23271",
  "customer-data-objects-ui-components": "static-1.13304",
  "customer-data-reference-ui-components": "static-1.13452",
  "customer-data-ui-utilities": "static-1.10102",
  "events-data-lib": "static-1.516",
  "framework-builder-read-service-client": "static-1.4201",
  "hs-resources": "static-1.465",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4037",
  "multi-account-reference-resolvers": "static-1.1273",
  "onboarding-scopes": "static-1.6726",
  "onboarding-tours": "static-1.17079",
  "pulse": "static-1.901",
  "reporting-datasets-permissions-lib": "static-1.14417",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2566",
  "trellis-components": "static-1.2585",
  "trellis-theming": "static-1.1243",
  "ui-addon-teams": "static-1.21880",
  "quartz-auth": "static-1.1097",
  "ui-business-units-lib": "static-1.9360",
  "usage-tracker-session-replay": "static-1.5315",
  "ai-components-ui-library": "static-1.9661",
  "ContentUtils": "static-1.69076",
  "customer-data-properties": "static-1.52503",
  "forms-ai-lib": "static-1.4728",
  "forms-utils-lib": "static-1.13059",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.26",
  "react-dnd-compat": "static-1.4890",
  "react-tinymce": "static-1.55929",
  "tinymce-config": "static-2.55055",
  "ui-gdpr-components": "static-1.10625",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3732",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3416",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.274",
  "ui-fonts": "static-1.1021",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4587",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1087",
  "web-vitals": "static-1.12",
  "batch-promise": "static-1.1816",
  "external-options-client-types": "static-1.4319",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7165",
  "quartz-i18n": "static-1.1097",
  "frontend-preferences-client": "static-1.8196",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3973",
  "reporting-client-types": "static-1.2665",
  "apollo-stack-hubspot": "static-3.91",
  "growth-payments-core": "static-1.26128",
  "hubspot-apollo-client": "static-1.5152",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.26",
  "quartz-routing": "static-1.852",
  "hs-story-utils": "static-1.9699",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.507",
  "seat-types-lib": "static-1.668",
  "timezone-utils": "static-2.5517",
  "react-create-root-preference": "static-1.67",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.26",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.43",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.574",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.418",
  "quartz-test": "static-1.1097",
  "quartz-tracking": "static-1.801",
  "bend-plugin-chirp-manifest": "static-1.348",
  "chirp-fetch": "static-1.2167",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6315",
  "salesImages": "static-1.537",
  "ts-schema": "static-1.4273",
  "bender-build-tools": "static-1.3422",
  "bend-plugin-foundations-theming": "static-1.3230",
  "restore-request-side-panel-lib": "static-1.1620",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4929",
  "conditional-properties-service-client": "static-1.3992",
  "crm-pipelines-api-client-types": "static-1.4328",
  "event-emitter": "static-1.1226",
  "fdsr-migration-layer": "static-1.284",
  "multi-currency-client-types": "static-1.3888",
  "getting-started-shared-tasks": "static-1.19185",
  "growth-data-modal": "static-1.5857",
  "growth-onboarding-confetti": "static-1.3335",
  "growth-onboarding-next-action-utils": "static-1.2640",
  "navigation-components": "static-1.18770",
  "onboarding-tours-client": "static-1.5293",
  "onboarding-tours-utils": "static-1.1145",
  "ui-shepherd-react": "static-3.10540",
  "ui-shepherd-tracker": "static-1.7921",
  "ui-universal-auth": "static-1.9350",
  "user-context": "static-1.5391",
  "bend-plugin-pulse": "static-1.404",
  "fast-json-patch": "static-1.67",
  "stylex-utils": "static-1.137",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10571",
  "magpie-lib": "static-1.5737",
  "navigation-messaging": "static-1.8097",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22840",
  "copilot-toolkit": "static-1.11804",
  "cms-field-types": "static-1.5088",
  "content-icons-ui": "static-1.2336",
  "integrations-lib": "static-1.16980",
  "calling-global-api": "static-1.65505",
  "calling-internal-common": "static-1.31591",
  "calling-lifecycle-internal": "static-1.66887",
  "calling-lifecycle-messages": "static-1.59181",
  "commerce-products-lib": "static-1.10475",
  "crm-index-visualization-core": "static-1.4509",
  "crm-links": "static-1.6602",
  "customer-data-properties-shared-msw-handlers": "static-1.9900",
  "file-manager-components": "static-1.24430",
  "formula-editor": "static-1.14715",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4406",
  "meetings-icalendar-utils-lib": "static-1.909",
  "object-builder-ui-client": "static-1.49609",
  "pipeline-validation-client-types": "static-1.4161",
  "property-value-citations": "static-1.3117",
  "smart-data-capture-core": "static-1.84",
  "smart-property-lib": "static-1.8236",
  "tiered-pricing": "static-1.1915",
  "topics-actions-lib": "static-1.437",
  "trial-components-library": "static-1.14066",
  "ui-addon-iframeable": "static-1.9350",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20270",
  "tinymce-themes": "static-1.57025",
  "data-token-picker": "static-1.16851",
  "hub-http-contrib": "static-1.3312",
  "interframe": "static-3.5028",
  "tinymce-data": "static-1.41140",
  "tinymce-plugins": "static-1.58169",
  "ui-addon-sales-email": "static-1.5486",
  "framework-data-schema-quick-fetch": "static-1.7070",
  "ui-addon-opt": "static-4.8637",
  "hubspot-apollo-cache": "static-1.611",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6318",
  "onboarding-data-sync-lib": "static-1.2465",
  "growth-onboarding-next-action-components": "static-1.2668",
  "user-context-client": "static-1.4782",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5197",
  "nest": "static-1.509",
  "reactive-lib": "static-1.993",
  "simple-logging-lib": "static-1.3324",
  "unified-auth-core-lib": "static-1.1146",
  "getting-started-shared-tasks-store": "static-1.18303",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1649",
  "integrations-error-boundary-lib": "static-1.14395",
  "integrations-tracking-lib": "static-1.5881",
  "native-integrations-shared-strings": "static-1.8052",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10642",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.864",
  "calling-error-reporting": "static-1.31598",
  "shared-worker-versioning": "static-1.11313",
  "calling-usage-tracker": "static-1.6810",
  "voice-sms-access-library": "static-1.1974",
  "customer-data-tracking": "static-1.7154",
  "commerce-permissions": "static-1.1050",
  "products-iframe-lib": "static-1.8541",
  "products-ui-components-shared-msw-handlers": "static-1.10955",
  "crm-index-associations-lib": "static-1.6714",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10656",
  "sales-views-client-types": "static-1.4528",
  "location-customization-utils-lib": "static-1.10047",
  "apollo-dlb": "static-3.97",
  "immerable": "static-1.4422",
  "video-components-external": "static-1.12107",
  "video-data-lib": "static-1.35765",
  "bark-lib": "static-1.16785",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6162",
  "react-codemirror": "static-1.10912",
  "data-agent-kit": "static-1.611",
  "feedback-loader": "static-1.29772",
  "fsm": "static-1.4021",
  "policy-lib": "static-1.7072",
  "react-colorpicker": "static-2.10481",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10719",
  "embedded-academy-lib": "static-1.15459",
  "hubs-service-types": "static-1.1530",
  "FileManagerLib": "static-1.40070",
  "NamespacedHubStyle": "static-2.9245",
  "FileManagerCore": "static-1.39929",
  "content-assistance-lib": "static-1.8165",
  "layout-dnd-components": "static-1.12928",
  "layout-dnd-utils": "static-1.11903",
  "ui-addon-emoji-picker": "static-1.10158",
  "ui-brand-identity-lib": "static-1.16368",
  "InboxConnectUtils": "static-4.15510",
  "meetings-connect-utils-lib": "static-1.7881",
  "breeze-engine-chat-components": "static-1.627",
  "breeze-engine-core": "static-1.927",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3281",
  "adobe-sign-auth-lib": "static-1.410",
  "ads-unified-auth-lib": "static-1.1214",
  "google-sheets-integration-lib": "static-1.982",
  "microsoft-drive-auth-lib": "static-1.77",
  "surveymonkey-integration-lib": "static-1.421",
  "slack-ui-library": "static-1.10671",
  "calling-orchestration-schema": "static-1.36751",
  "crm-record-cards-service-types": "static-1.3767",
  "content-media-composition-data-lib": "static-1.13183",
  "content-media-compositions": "static-2.17190",
  "media-bridge-lib": "static-1.19371",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16316",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4782",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14919",
  "audio-components": "static-1.6306",
  "FileManagerImages": "static-1.37581",
  "video-components": "static-1.14109",
  "breeze-artifacts-sdk": "static-1.256",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4806",
  "video-embed": "static-1.36599",
  "ui-addon-video-player": "static-1.8975",
  "ui-coaching-tips": "static-1.29260",
  "ContentData": "static-1.69151",
  "layout-data-lib": "static-1.10228",
  "academy-service-client": "static-1.3961",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4676",
  "trellis-ecosystem": "static-1.7593",
  "ui-addon-react-router-dom": "static-1.9811",
  "wootric-nps": "static-1.7179",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4431",
  "growth-onboarding-feedback-components": "static-1.6856",
  "advanced-menus-core": "static-1.15541",
  "advanced-menus-lib": "static-1.12418",
  "ExportDialog": "static-6.10652",
  "ui-memberships-settings-lib": "static-1.34792",
  "marketplace-ui-apps-core": "static-1.19196",
  "marketplace-ui-common": "static-1.20664",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15540",
  "simple-menus-lib": "static-1.17057",
  "developer-experience-shared-components": "static-1.10777",
  "immutable-less": "static-1.4923",
  "marketplace-ui-client-types": "static-1.18071",
  "ui-addon-integrations-directory-panel": "static-2.8297",
  "ui-extensibility-client-types": "static-1.4191",
  "ai-settings-ui-library": "static-1.8287",
  "nav-meta": "static-1.30407",
  "ui-product-approvals-common": "static-1.965",
  "apps-service-types": "static-1.4013",
  "oauth-service-types": "static-1.4509",
  "simple-data-table": "static-1.3487"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35177",
  "atom": "/atom/static-1.5358",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2766",
  "client-types": "/client-types/static-1.496",
  "cssUtils": "/cssUtils/static-1.893",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40836",
  "customer-data-objects": "/customer-data-objects/static-1.7963",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8375",
  "documents-lib": "/documents-lib/static-1.35182",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.365",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86509",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5000",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2463",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5870",
  "hs-test-utils": "/hs-test-utils/static-1.8305",
  "hub-http": "/hub-http/static-1.6486",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12066",
  "HubStyleTokens": "/HubStyleTokens/static-2.11759",
  "I18n": "/I18n/static-7.1668",
  "icons": "/icons/static-2.677",
  "jasmine-immutable": "/jasmine-immutable/static-1.3294",
  "jasmine-runner": "/jasmine-runner/static-1.6725",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7424",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3168",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5671",
  "quartz": "/quartz/static-1.7422",
  "react": "/react/static-7.192",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16990",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5537",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8455",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8376",
  "reporting-data": "/reporting-data/static-1.68727",
  "reporting-reports": "/reporting-reports/static-1.68404",
  "reporting-snowflake": "/reporting-snowflake/static-1.57344",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10660",
  "reporting-visualizations": "/reporting-visualizations/static-1.60802",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9224",
  "sanitize": "/sanitize/static-1.4747",
  "sanitize-text": "/sanitize-text/static-1.8427",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2020",
  "signup-constants": "/signup-constants/static-1.19565",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8335",
  "StyleGuideUI": "/StyleGuideUI/static-3.500",
  "superstore": "/superstore/static-1.5030",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5031",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11256",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11371",
  "ui-images": "/ui-images/static-2.1238",
  "UIComponents": "/UIComponents/static-3.8705",
  "usage-tracker": "/usage-tracker/static-1.7629",
  "usage-tracker-container": "/usage-tracker-container/static-1.7619",
  "usage-tracker-core": "/usage-tracker-core/static-1.7479",
  "viral-links-lib": "/viral-links-lib/static-1.7349",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9931",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.26",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1200",
  "quartz-core": "/quartz-core/static-1.6641",
  "quick-fetch": "/quick-fetch/static-1.4111",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4938",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11419",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18347",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3600",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3699",
  "quartz-webpack": "/quartz-webpack/static-1.3646",
  "foundations-assets": "/foundations-assets/static-1.5156",
  "foundations-theming": "/foundations-theming/static-1.4747",
  "hub-http-janus": "/hub-http-janus/static-1.874",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10573",
  "hubspotter-http": "/hubspotter-http/static-1.4844",
  "sassPrefix": "/sassPrefix/static-1.166",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7519",
  "crm-message-bus": "/crm-message-bus/static-1.43702",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23271",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13304",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13452",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10102",
  "events-data-lib": "/events-data-lib/static-1.516",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4201",
  "hs-resources": "/hs-resources/static-1.465",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4037",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1273",
  "onboarding-scopes": "/onboarding-scopes/static-1.6726",
  "onboarding-tours": "/onboarding-tours/static-1.17079",
  "pulse": "/pulse/static-1.901",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14417",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2566",
  "trellis-components": "/trellis-components/static-1.2585",
  "trellis-theming": "/trellis-theming/static-1.1243",
  "ui-addon-teams": "/ui-addon-teams/static-1.21880",
  "quartz-auth": "/quartz-auth/static-1.1097",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9360",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5315",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9661",
  "ContentUtils": "/ContentUtils/static-1.69076",
  "customer-data-properties": "/customer-data-properties/static-1.52503",
  "forms-ai-lib": "/forms-ai-lib/static-1.4728",
  "forms-utils-lib": "/forms-utils-lib/static-1.13059",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.26",
  "react-dnd-compat": "/react-dnd-compat/static-1.4890",
  "react-tinymce": "/react-tinymce/static-1.55929",
  "tinymce-config": "/tinymce-config/static-2.55055",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3732",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3416",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.274",
  "ui-fonts": "/ui-fonts/static-1.1021",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4587",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1087",
  "web-vitals": "/web-vitals/static-1.12",
  "batch-promise": "/batch-promise/static-1.1816",
  "external-options-client-types": "/external-options-client-types/static-1.4319",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7165",
  "quartz-i18n": "/quartz-i18n/static-1.1097",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8196",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3973",
  "reporting-client-types": "/reporting-client-types/static-1.2665",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "growth-payments-core": "/growth-payments-core/static-1.26128",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5152",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.26",
  "quartz-routing": "/quartz-routing/static-1.852",
  "hs-story-utils": "/hs-story-utils/static-1.9699",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.507",
  "seat-types-lib": "/seat-types-lib/static-1.668",
  "timezone-utils": "/timezone-utils/static-2.5517",
  "react-create-root-preference": "/react-create-root-preference/static-1.67",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.26",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.43",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.418",
  "quartz-test": "/quartz-test/static-1.1097",
  "quartz-tracking": "/quartz-tracking/static-1.801",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.348",
  "chirp-fetch": "/chirp-fetch/static-1.2167",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6315",
  "salesImages": "/salesImages/static-1.537",
  "ts-schema": "/ts-schema/static-1.4273",
  "bender-build-tools": "/bender-build-tools/static-1.3422",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3230",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1620",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4929",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3992",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4328",
  "event-emitter": "/event-emitter/static-1.1226",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.284",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3888",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19185",
  "growth-data-modal": "/growth-data-modal/static-1.5857",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3335",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2640",
  "navigation-components": "/navigation-components/static-1.18770",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5293",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1145",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10540",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7921",
  "ui-universal-auth": "/ui-universal-auth/static-1.9350",
  "user-context": "/user-context/static-1.5391",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.404",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "stylex-utils": "/stylex-utils/static-1.137",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10571",
  "magpie-lib": "/magpie-lib/static-1.5737",
  "navigation-messaging": "/navigation-messaging/static-1.8097",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22840",
  "copilot-toolkit": "/copilot-toolkit/static-1.11804",
  "cms-field-types": "/cms-field-types/static-1.5088",
  "content-icons-ui": "/content-icons-ui/static-1.2336",
  "integrations-lib": "/integrations-lib/static-1.16980",
  "calling-global-api": "/calling-global-api/static-1.65505",
  "calling-internal-common": "/calling-internal-common/static-1.31591",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66887",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59181",
  "commerce-products-lib": "/commerce-products-lib/static-1.10475",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4509",
  "crm-links": "/crm-links/static-1.6602",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9900",
  "file-manager-components": "/file-manager-components/static-1.24430",
  "formula-editor": "/formula-editor/static-1.14715",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4406",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.909",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49609",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4161",
  "property-value-citations": "/property-value-citations/static-1.3117",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.84",
  "smart-property-lib": "/smart-property-lib/static-1.8236",
  "tiered-pricing": "/tiered-pricing/static-1.1915",
  "topics-actions-lib": "/topics-actions-lib/static-1.437",
  "trial-components-library": "/trial-components-library/static-1.14066",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9350",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20270",
  "tinymce-themes": "/tinymce-themes/static-1.57025",
  "data-token-picker": "/data-token-picker/static-1.16851",
  "hub-http-contrib": "/hub-http-contrib/static-1.3312",
  "interframe": "/interframe/static-3.5028",
  "tinymce-data": "/tinymce-data/static-1.41140",
  "tinymce-plugins": "/tinymce-plugins/static-1.58169",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5486",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7070",
  "ui-addon-opt": "/ui-addon-opt/static-4.8637",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.611",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6318",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2465",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2668",
  "user-context-client": "/user-context-client/static-1.4782",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5197",
  "nest": "/nest/static-1.509",
  "reactive-lib": "/reactive-lib/static-1.993",
  "simple-logging-lib": "/simple-logging-lib/static-1.3324",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1146",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18303",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1649",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14395",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5881",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8052",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10642",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.864",
  "calling-error-reporting": "/calling-error-reporting/static-1.31598",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11313",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6810",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1974",
  "customer-data-tracking": "/customer-data-tracking/static-1.7154",
  "commerce-permissions": "/commerce-permissions/static-1.1050",
  "products-iframe-lib": "/products-iframe-lib/static-1.8541",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10955",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6714",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10656",
  "sales-views-client-types": "/sales-views-client-types/static-1.4528",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10047",
  "apollo-dlb": "/apollo-dlb/static-3.97",
  "immerable": "/immerable/static-1.4422",
  "video-components-external": "/video-components-external/static-1.12107",
  "video-data-lib": "/video-data-lib/static-1.35765",
  "bark-lib": "/bark-lib/static-1.16785",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6162",
  "react-codemirror": "/react-codemirror/static-1.10912",
  "data-agent-kit": "/data-agent-kit/static-1.611",
  "feedback-loader": "/feedback-loader/static-1.29772",
  "fsm": "/fsm/static-1.4021",
  "policy-lib": "/policy-lib/static-1.7072",
  "react-colorpicker": "/react-colorpicker/static-2.10481",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10719",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15459",
  "hubs-service-types": "/hubs-service-types/static-1.1530",
  "FileManagerLib": "/FileManagerLib/static-1.40070",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9245",
  "FileManagerCore": "/FileManagerCore/static-1.39929",
  "content-assistance-lib": "/content-assistance-lib/static-1.8165",
  "layout-dnd-components": "/layout-dnd-components/static-1.12928",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11903",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10158",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16368",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15510",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7881",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.627",
  "breeze-engine-core": "/breeze-engine-core/static-1.927",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3281",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.410",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1214",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.982",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.77",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.421",
  "slack-ui-library": "/slack-ui-library/static-1.10671",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36751",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3767",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13183",
  "content-media-compositions": "/content-media-compositions/static-2.17190",
  "media-bridge-lib": "/media-bridge-lib/static-1.19371",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16316",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4782",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14919",
  "audio-components": "/audio-components/static-1.6306",
  "FileManagerImages": "/FileManagerImages/static-1.37581",
  "video-components": "/video-components/static-1.14109",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.256",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4806",
  "video-embed": "/video-embed/static-1.36599",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8975",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29260",
  "ContentData": "/ContentData/static-1.69151",
  "layout-data-lib": "/layout-data-lib/static-1.10228",
  "academy-service-client": "/academy-service-client/static-1.3961",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4676",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7593",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9811",
  "wootric-nps": "/wootric-nps/static-1.7179",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4431",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6856",
  "advanced-menus-core": "/advanced-menus-core/static-1.15541",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12418",
  "ExportDialog": "/ExportDialog/static-6.10652",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34792",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19196",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20664",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15540",
  "simple-menus-lib": "/simple-menus-lib/static-1.17057",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10777",
  "immutable-less": "/immutable-less/static-1.4923",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18071",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8297",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4191",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8287",
  "nav-meta": "/nav-meta/static-1.30407",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.965",
  "apps-service-types": "/apps-service-types/static-1.4013",
  "oauth-service-types": "/oauth-service-types/static-1.4509",
  "simple-data-table": "/simple-data-table/static-1.3487"
}
};
